module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/CrONnx/tc-custom/9780310559832.jpg?1736424833423",
      "alt": "This image is the cover for the book God's Handmaiden"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("God's Handmaiden\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A historical and romantic adventure woven around the story of Florence Nightingale.Gervase Howard is in her mid-teens when her working-class mother dies and she must go to live with relatives in service to a wealthy, noble family, outside of London. While learning various jobs, she is drawn to the eldest son, Davis. Her fascination with him grows deeper, but more hopeless, since the two are separated not just by class, but also by Davis’s love for Roberta.When Davis announces his engagement, he asks Gervase to join them as Roberta’s maid. But instead Gervase becomes a companion to Florence Nightingale and accompanies her when the Crimean War breaks out and she is asked to create a corps of nurses. On the field, Gervase crosses paths with Davis, who has become disillusioned in his marriage and is drawn to her warmth and care. Both know, however, there is nothing more for them than friendship.Upon her return to England, Gervase receives word that Davis has been seriously injured in a fall and is asked to nurse him back to health. As he regains consciousness, he reveals shocking news that plunges them both into danger.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gilbert Morris\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Gilbert Morris is one of today’s best-known Christian novelists, specializing in historical fiction. His best-selling works include Edge of Honor (winner of a Christy Award in 2001), Jacob’s Way, The Spider Catcher, the House of Winslow series, the Appomattox series, and The Wakefield Saga. He lives in Gulf Shores, Alabama with his wife, Johnnie.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Zondervan\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0